"use client"

import type { ReactNode } from "react"
import { useSite } from "@/contexts/site/site.context"

type EmailLinkProps = {
  readonly className?: string
  readonly emailAddress: string
  readonly children?: ReactNode
  readonly position?: string
  readonly onMouseEnter?: () => void
  readonly onMouseLeave?: () => void
}

export function EmailLink({
  children,
  className,
  emailAddress,
  position,
  onMouseEnter,
  onMouseLeave,
}: EmailLinkProps) {
  const { domain } = useSite()

  return (
    <a
      className={className}
      data-k5a-pos={position}
      data-k5a-url={`https://${domain}/mailto`} // Kilkaya does not support mailto links, so we have to provide an url for it to work.
      href={`mailto:${emailAddress}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children ?? emailAddress}
    </a>
  )
}
